import { gql } from '@/apollo';

export const SUBMIT_BUG_REPORT = gql`
  mutation SubmitBugReport($input: BugReportInput!) {
    submitBugReport(input: $input) {
      success
      message
    }
  }
`;

